var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"frame",staticClass:"chatwoot-teste-frame",attrs:{"src":_vm.url,"title":"Conversa de teste do fluxo"},on:{"load":_vm.enviarConfiguracao,"error":_vm.falharCarregamento}})}
var staticRenderFns = []

export { render, staticRenderFns }